export enum PurchaseOrderInvoiceStatusEnum {
  NO_MATCH = 1,
  PARTIAL_MATCH = 2,
  MATCHED = 3,
  APPROVED = 4,
  MATCHING_NOT_APPLICABLE = 5
}
